
import $ from 'jquery'
import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import store from './store/store'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

// import './permissions' // 全局路由钩子

import md5 from 'js-md5';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
// 配置放大图片的特效
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});
Vue.use(Vuex);
Vue.prototype.$md5 = md5;
Vue.prototype.Storage = Storage

ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI);

Vue.prototype.$ = $
import axios from 'axios'
Vue.prototype.$axios = axios;

import qs from 'qs';
Vue.prototype.$qs = qs;

import _ from 'lodash'
Vue.prototype._ = _

import { Message, Loading } from 'element-ui'
import { relative } from 'path'
//配置axios 实现跨域请求3000端口下的node服务器
var loadingInstance
// POST传参序列化(添加请求拦截器)
// axios.defaults.baseURL = '/api'
// axios.defaults.baseURL = '/apis'
  
// let base = process.env.NODE_ENV === 'production' ? 'http://demo.cmsmate.com.cn' : 'http://localhost:8080';
// Vue.prototype.baseURL = base;

function getPaths(json) {
  var o = []; //专门用来保存筛选后的数组
  //定义一个函数getID(json,id)，形参json用来接受传入的数组，形参id用来接受id号
  //核心：利用arry.forEach(function(currentValue),index,arr)遍历数组
  json.forEach(function(item) {
  //if用来判断外层，else if用来判断里层，调用递归函数的有2个判断条件在“有goods属性并且不为空”情况下才调用
     if (item.children && item.children.length > 0) {
          o.concat(getPaths(item.children))//递归
      }else{
         o[item.id]=item.path; 
      }
  });
  return o; //全部遍历完之后返回对象o
}


axios.interceptors.request.use(
  config => {

    //   loadingInstance = Loading.service({
    //   lock: true,
    //   text: '数据加载中，请稍后...',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(0, 0, 0, 0.7)'

    // })

    // console.log('1111111111111', userToken)
    //判断请求方式是否为POST，进行转换格式   对于multipart/form-data不做处理，不然会提交失败
    if (config.method === 'post' && (!config.headers['Content-Type'] || config.headers['Content-Type'].indexOf('multipart') === -1) ) {
      config.data = qs.stringify({ ...config.data })
    } else if (config.method === 'get') {
      config.params = { ...config.params }
    }
    if (localStorage.getItem('Authorization')) {

        config.headers.Authorization = localStorage.getItem('Authorization');

    }
    // config.method === 'post'
    //   ? config.data = qs.stringify({ ...config.data })
    //   : config.params = { ...config.params };
    // 请求发送前进行处理
    // if (store.getters.token) {
    //   config.headers['Authorization'] = getToken()
    // }
    return config
  },
  error => {


    store.commit('CLOSE_LOADING');
    // 请求错误处理  loadingInstance.close();
    return Promise.reject(error)

  }
)



// 添加响应拦截器
// // 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(res => {
//   console.log(res.status, 'status')
//   console.log(res.data.result, 'result')
  if (res.status === 200) {
    // console.log('拦截:', res.data)
      if (parseInt(res.data.state) === 410001 || parseInt(res.data.state) === 410000) {
        if (res.data.err) { Message.warning(res.data.err) }
        else { Message.warning(res.data.msg) }

        testVueInstance.$router.push('/login')
        // location.reload()
        window.localStorage.clear()
        return res
    }
  } else {
    Message.error(res.data.info.message)
  }

  if (res.data.result == 501) {
    console.log('501')
    testVueInstance.$router.push('/login')
    location.reload();
  }
  return res
}, err => {
  Message.error('请求失败，请稍后再试')
  return Promise.reject(err)
})
// import api from '@/api/api';
// Vue.prototype.$api = api;


router.beforeEach((to, from, next) => {
//   console.log(to, from, next);
    if (to.path === '/home') { 
    
        //使用token
  
    //     // console.log(22222);
    //     let token = localStorage.getItem('Authorization');
    //     console.log(token)
    //     if (token === null || token === '') {
    //         alert("请先登录")

    //         next('/login');

    //     } else {
    //         next();

    //     }



        if (sessionStorage.getItem('userId')) { // 已经登陆       
            next()   // 正常跳转到你设置好的页面     
        } else {
        // alert("请先登录")

        // 未登录则跳转到登陆界面，query:{ Rurl: to.fullPath}表示把当前路由信息传递过去方便登录后跳转回来；
        // next({ path: '/login', query: { Rurl: to.fullPath } })
            next({ path: '/login' })
        }
  }
  //  else if ( to.path == '/admin'){
  //   if (!sessionStorage.getItem('nickname')) { // 已经登陆       
  //     next({ path: '/admin/login' }) 
  //   } else{
  //     next()
  //   }  
  // }
   else {
    next()
  }

  // 对路由进行验证     


})




let testVueInstance = new Vue({
  el: '#app',
  router,
  store,//使用vuex的store
  components: { App },
  template: '<App/>',
  data () { // 全局变量
    return {
      web_title: '',          // web标题
      web_logo: '',           // logo地址
      web_logo_height: '',    // logo高度
      web_top_bc: '',         // 头部背景色
      
      auditPattern1: true,    // 增强模式
      auditPattern2: false,   // 智能模式
      auditPattern3: false,   // 疑似错别字

      clientType: 0 // 0-标准版本 1-客户独立安装版本
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js